'use strict';

import { isMobile, isTablet } from '../../settings';

export class Cloudflare {
    static active = config.resources.cloudflare?.active || false;
    static settings = config.resources.cloudflare?.settings || {};
    static version  = config.resources.cloudflare?.version || null;

    static resize(path, manualParams, addVersion = true,checkIsImage = true) {
        if (!Cloudflare.active)
            return path;

        let params;

        if (manualParams) {
            params = manualParams;
        } else {
            params = (isMobile || isTablet) ? Cloudflare.settings.mobile : Cloudflare.settings.web;
        }
        
        if (typeof path === 'string' && (!path.startsWith(config.cdnRepository) || (!Cloudflare.isImage(path) && checkIsImage)))
            return path;
        
        if (path instanceof URL && !Cloudflare.isImage(path.pathname) && checkIsImage) {
            return;
        }
        
        const url  = new URL(path);
        let paramsString = '';
        const maxIndex = Object.keys(params).length - 1;

        Object.entries(params).forEach(([key,value],index) => {
            paramsString += `${key}=${value}`;

            if ( maxIndex !== index)
                paramsString += ',';
        });

        let modifiedUrl = `${url.origin}/resize/image/${paramsString}${url.pathname}`;

        if (Cloudflare.version && addVersion) {
            modifiedUrl += `?v=${Cloudflare.version}`;
        }


        return modifiedUrl;
    }

    static isImage(path) {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
        const fileExtension = path.slice((path.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
        return imageExtensions.includes(fileExtension);
    }
}
